export enum ArticleStoreType {
  HOMEPAGE = 'homepage',
  SECTION = 'section',
  SEARCH = 'search',
  AUTHOR = 'author',
  NEWSROOM = 'newsroom',
  ARTICLE_DETAIL = 'article_detail',
  ARTICLE_GALLERY = 'article_gallery',
  CURRENT_EDITION = 'current_edition',
}